module.exports = __webpack_public_path__ + "img/mainImg_tablet.9725aa3c.webp";